<template>
  <tr>
    <td>
      <div style="height:1px;width:100%;background:#ccc;margin:5px 0;"></div>
    </td>
  </tr>
</template>

<script>
export default {
  name: 'Divider'
}
</script>

<style scoped>
</style>
